import type { Reducer } from 'types/redux';
import {
  SET_TEMPLATE_ID,
  SET_IS_CUSTOM_TEMPLATE_PUBLISHED,
} from './customTemplateActionTypes';

export interface CustomTemplateState {
  templateId: string | undefined;
  isCustomTemplatePublished: boolean | undefined;
}

export const customTemplateInitialState: CustomTemplateState = {
  templateId: undefined,
  isCustomTemplatePublished: undefined,
};

const reducer: Reducer<CustomTemplateState> = (
  customTemplate = customTemplateInitialState,
  action,
) => {
  switch (action.type) {
    case SET_TEMPLATE_ID:
      return { ...customTemplate, templateId: action.templateId };
    case SET_IS_CUSTOM_TEMPLATE_PUBLISHED:
      return {
        ...customTemplate,
        isCustomTemplatePublished: action.isCustomTemplatePublished,
      };
    default:
      return customTemplate;
  }
};

export default reducer;
